import React, { createContext, useContext } from 'react'
import type { Article, Category } from '../services/help-center-query.service'

type ArticlesContextType = {
  allArticles: Article[] | null
  categories: {
    isLoading: boolean | false
    data: Category[] | null
  }
  searched: {
    isLoading: boolean | false
    data: Article[] | null
    term: string
  }
}

export const ArticlesContext = createContext<ArticlesContextType>({
  allArticles: null,
  categories: { isLoading: false, data: null },
  searched: { isLoading: false, data: null, term: '' },
})

export const useArticles = () => useContext(ArticlesContext)
